import React, {Component} from 'react';
import {createPortal} from 'react-dom';
import TileLayer from './TileLayer';
import MapImageLayer from './MapImageLayer';
import GraphicsLayer from './GraphicsLayer';
import {SelectZIPRoute, SelectZIPBox, SelectNearRoute, SelectNearBox, SelectCityState} from './geoprocessors';
import {Geolocator} from './locators';
import EventHandler from './EventHandler';
import {loadModules, Map} from 'react-arcgis';
import PropTypes from 'prop-types';
import LocationControl from './LocationControl';
import './EDDMMap.css';
import MapAccesor from './MapAccesor';
import ViewAccesor from './ViewAccesor';

import {Table, Button, Input, Form} from 'reactstrap';

import ElementTable from './ElementTable';
import CardRoutes from './CardRoutes';
import RouteInformation from './RouteInformation';
import {
  addRoute,
  addCost,
  addHomes,
  deleteRoute,
  subtractCost,
  loadRoutesList,
  subtractHome,
  activeRoute,
  deactiveRoute,
  clearTable,
  addBusiness,
  subtractBusiness,
  excludedBusiness,
  hoveredRoute,
  unhoveredRoute,
  resetSelectedRoutes
} from '../actions';
import {connect} from 'react-redux';

class EDDMMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      address: 'Glendale, CA',
      center: [-118.2551, 34.1425],
      routes: [],
      selectedRoutes: [],
      homes: 0,
      costs: 0,
      loading: false,
      routeTableModalOpen: false
    };
    this.selectZIPR = React.createRef();
    this.selectZIPB = React.createRef();
    this.selectNearR = React.createRef();
    this.selectNearB = React.createRef();
    this.selectCity = React.createRef();
    this.cridLayer = React.createRef();
    this.geolocator = React.createRef();
    this.mapAccesor = React.createRef();
    this.viewAccesor = React.createRef();
    this.selectedRoutes = {
      features: [],
      usedSearch: '',
      searchType: '',
      searchRadius: 0,
      candidate: '',
      msgs: []
    };
    this.newRoutes = {
      features: []
    };
    /**
         * @description Results returned from geocode service
         * @property
         * @name matchedResults
         * @type JSON Array
         * @default
         */
    this.matchedResults = {
      spatialReference: {
        wkid: 102100
      },
      candidates: [],
      usedSearch: ''
    };
    /**

         * @description Address used for the search
         * @property
         * @name addressSearched
         * @type JSON
         * @default
         */
    this.addressSearched = {
      location: '',
      zip: [],
      searchUsed: '',
      distance: 1
    };
    this.initializeSymbols();
  }

  toggleRouteTableModal = () => {
    this.setState((prev) => ({ routeTableModalOpen: !prev.routeTableModalOpen }));
  };

  handleRouteModalEscape = (e) => {
    if (e.key === 'Escape') {
      e.stopPropagation();
      this.setState({ routeTableModalOpen: false });
    }
  };

  clearAll = () => {
      /*
        this.selectedRoutes = {
          features: [],
          usedSearch: '',
          searchType: '',
          searchRadius: 0,
          candidate: '',
          msgs: []
        };
        this.newRoutes = {
          features: []
        };
        this.cridLayer.current.getLayer().removeAll();
        this.viewAccesor.current.getView().graphics = [];
        this.props.clearTable();
        */
      this.cridLayer.current.getLayer().graphics.forEach(graphic => {
        graphic.symbol = graphic.offSymbol;
        graphic.selected = false;
      });
      this.props.resetSelectedRoutes();
    };

  renderRouteTableModal() {
    return (
      <div
        className="eddm-routes-modal-root"
        role="dialog"
        aria-modal="true"
        aria-labelledby="eddm-routes-modal-title"
      >
        <button
          type="button"
          className="eddm-routes-modal-backdrop"
          aria-label="Close routes table"
          onClick={this.toggleRouteTableModal}
        />
        <div className="eddm-routes-modal-panel">
          <div className="eddm-routes-modal-panel-header">
            <h2 className="eddm-routes-modal-panel-title" id="eddm-routes-modal-title">
              Routes in this search
            </h2>
            <button
              type="button"
              className="eddm-routes-modal-close"
              onClick={this.toggleRouteTableModal}
              aria-label="Close"
            >
              &times;
            </button>
          </div>
          <div className="eddm-routes-modal-panel-body">
            <div className="eddm-routes-table-wrap eddm-routes-table-modal">
              {this.props.routes.length === 0 ? (
                <p className="eddm-routes-modal-empty text-muted small mb-0 py-4 px-3 text-center">
                  Search for a ZIP or address and load routes to see the table.
                </p>
              ) : (
                <Table responsive hover size="sm" className="mb-0">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col">Route</th>
                      <th scope="col">Res.</th>
                      <th scope="col">Bus.</th>
                      <th scope="col">Total</th>
                      <th scope="col">Size</th>
                      <th scope="col">Income</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.routes.map((route, index) => (
                      <ElementTable
                        route={route}
                        key={route.attributes?.ZIP_CRID || index}
                        actived={!!route.active}
                      />
                    ))}
                  </tbody>
                </Table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
      return (
        <div className="eddm-layout">
          <div className="eddm-map-stage">
            <div className="eddm-map-toolbar">
              <Form onSubmit={this.searchAddressNormal} className="eddm-map-toolbar-inner">
                <Input
                  className="eddm-toolbar-search"
                  placeholder="Search"
                  type="text"
                  value={this.state.address}
                  onChange={this.handleChange}
                />
                <div className="eddm-toolbar-actions">
                  <Button type="submit" className="eddm-btn eddm-btn-black">
                    Find routes
                  </Button>
                  <Button
                    type="button"
                    className="eddm-btn eddm-btn-pink"
                    onClick={this.toggleRouteTableModal}
                  >
                    {this.state.routeTableModalOpen ? 'Hide table view' : 'Show table view'}
                  </Button>
                  <button
                    type="button"
                    className="eddm-toolbar-clear-icon"
                    onClick={this.clearAll}
                    aria-label="Clear routes"
                    title="Clear routes"
                  >
                    <img
                      src="https://static.thenounproject.com/png/5507757-200.png"
                      alt=""
                      width="26"
                      height="26"
                      decoding="async"
                      className="eddm-toolbar-clear-icon-img"
                    />
                  </button>
                </div>
              </Form>
            </div>
            {this.state.loading && (
              <div className="eddm-map-loading d-flex align-items-center gap-2">
                <div className="spinner-border text-primary" role="status" aria-label="Loading routes">
                  <span className="visually-hidden">Loading…</span>
                </div>
                <span className="ms-2 text-secondary small">Loading routes…</span>
              </div>
            )}
            <div className="map-container">
              <Map
                loaderOptions={{
                  dojoConfig: {
                    has: {
                      'esri-promise-compatibility-deprecation-warnings': 0,
                      'esri-promise-compatibility': 0
                    }
                  }
                }}
                viewProperties={{
                  zoom: this.props.zoom || 10,
                  center: [-118.2551, 34.1425]
                }}
              >
                <MapAccesor ref={this.mapAccesor}/>
                <ViewAccesor ref={this.viewAccesor}/>
                <LocationControl center={this.state.center}/>
                <EventHandler event="click" callback={this.onClick}/>
                <EventHandler event="pointer-move" callback={this.onPointerMove}/>
                <EventHandler event="pointer-down" callback={this.onPointerMove}/>
                <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer"/>
                <MapImageLayer url="https://gis.usps.com/arcgis/rest/services/EDDM/EDDM_ZIP5/MapServer"/>
                <Geolocator ref={this.geolocator} baseUrlService="https://gis.usps.com/arcgis/rest/services/"/>
                <GraphicsLayer ref={this.cridLayer} id="cridLayer"/>
                <SelectZIPRoute ref={this.selectZIPR} baseUrlService="https://gis.usps.com/arcgis/rest/services/"/>
                <SelectZIPBox ref={this.selectZIPB} baseUrlService="https://gis.usps.com/arcgis/rest/services/"/>
                <SelectNearRoute ref={this.selectNearR} baseUrlService="https://gis.usps.com/arcgis/rest/services/"/>
                <SelectNearBox ref={this.selectNearB} baseUrlService="https://gis.usps.com/arcgis/rest/services/"/>
                <SelectCityState ref={this.selectCity} baseUrlService="https://gis.usps.com/arcgis/rest/services/"/>
              </Map>
            </div>

            {this.state.routeTableModalOpen
              ? createPortal(this.renderRouteTableModal(), document.body)
              : null}
          </div>

          <aside className="eddm-sidebar" aria-label="EDDM search and order">
            <header className="eddm-sidebar-header">
              <h1>Every Door Direct Mail</h1>
              <p>Search an address or ZIP, then select routes on the map. Use &ldquo;Continue to product&rdquo; when ready.</p>
            </header>

            <div className="eddm-sidebar-scroll">
              <div className="eddm-routes-table-wrap">
                <p className="eddm-hover-table-hint small text-muted mb-2 px-2 pt-2">
                  Hover a route on the map for details. Use &ldquo;Show table view&rdquo; for the full list.
                </p>
                <Table responsive hover size="sm">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col">Route</th>
                      <th scope="col">Res.</th>
                      <th scope="col">Bus.</th>
                      <th scope="col">Total</th>
                      <th scope="col">Size</th>
                      <th scope="col">Income</th>
                    </tr>
                  </thead>
                  <tbody>
                    <RouteInformation/>
                  </tbody>
                </Table>
              </div>

              <CardRoutes
                routes={this.props.routes}
                handleExcludedBusiness={this.props.handleExcludedBusiness}
                excludedBusiness={this.props.excludedBusiness}
                business={this.props.business}
                costs={this.props.costs}
                homes={this.props.homes}
              />
            </div>
          </aside>
        </div>
      );
    }

    componentWillUnmount() {
      document.removeEventListener('keydown', this.handleRouteModalEscape, true);
      document.body.style.overflow = '';
    }

    componentDidMount() {
      this.initializeSymbols();
    }

    componentDidUpdate(prevProps, prevState) {
      if (this.state.routeTableModalOpen !== prevState.routeTableModalOpen) {
        if (this.state.routeTableModalOpen) {
          document.addEventListener('keydown', this.handleRouteModalEscape, true);
          document.body.style.overflow = 'hidden';
        } else {
          document.removeEventListener('keydown', this.handleRouteModalEscape, true);
          document.body.style.overflow = '';
        }
      }

      let zipCodes = this.props.routes.filter(route => route.active).map(route => route.attributes.ZIP_CRID);
      let prevZipCodes = prevProps.routes.filter(route => route.active).map(route => route.attributes.ZIP_CRID);

      // Compare zipCodes and detect if is needed change information.
      if (zipCodes.join('_') !== prevZipCodes.join('_')) {
        this.cridLayer.current.getLayer().graphics.forEach(graphic => {
          if (zipCodes.includes(graphic.attributes.ZIP_CRID)) {
            graphic.symbol = graphic.selectedSymbol;
            graphic.selected = true;
            graphic.hovered = false;
          } else {
            graphic.symbol = graphic.defaultSymbol;
            graphic.selected = false;
          }
        });
      }
    }

    onClick = (event, view) => {
      let promise = view.hitTest(event);
      promise = promise.then(response => {
        let results = response.results.filter(result => {
          return result.graphic.layer === this.cridLayer.current.getLayer();
        });

        if (results.length === 0) {
          return;
        }

        let graphic = results[0].graphic;

        if (graphic !== undefined) {
          if (graphic.selected) {
            graphic.symbol = graphic.offSymbol;
            graphic.selected = false;
            console.log(graphic.attributes);
            this.props.deactiveRoute(graphic.attributes.ZIP_CRID);
            this.props.subtractCost(graphic.attributes.TOT_CNT);
            this.props.subtractHome(graphic.attributes.RES_CNT);
            this.props.subtractBusiness(graphic.attributes.BUS_CNT);
          } else {
            graphic.symbol = graphic.selectedSymbol;
            graphic.selected = true;
            graphic.hovered = false;

            this.props.activeRoute(graphic.attributes.ZIP_CRID);
            this.props.addHome(graphic.attributes.RES_CNT);
            this.props.addCost(graphic.attributes.TOT_CNT);

            this.props.addBusiness(graphic.attributes.BUS_CNT);
          }
        }
      }, error => {
        console.log(error);
      });
    };

    onPointerMove = (event, view) => {
      let promise = view.hitTest(event);
      promise.then(response => {
        console.log(response.results);
        let results = response.results.filter(result => {
          return result.graphic.layer === this.cridLayer.current.getLayer();
        });

        if (results.length === 0) {
          this.props.unhoveredRoute();
          this.cridLayer.current.getLayer().graphics.forEach(grap => {
            if (grap.hovered) {
              grap.symbol = grap.prevSymbol;
              grap.hovered = false;
            }
          });

          return;
        }

        let graphic = results[0].graphic;

        if (!graphic.hovered) {
          this.props.hoveredRoute(graphic.attributes);
          if (!graphic.selected) {
            this.cridLayer.current.getLayer().graphics.forEach(grap => {
              if (grap.hovered) {
                grap.symbol = grap.prevSymbol;
                grap.hovered = false;
              }
            });

            graphic.prevSymbol = graphic.symbol;
            graphic.symbol = graphic.hoveredSymbol;
            graphic.hovered = true;
          }
        }
      }, reason => {
        console.error(reason);
      });
    };

    /**
     * Initialize ArcGIS symbols from server using loadModules (async).
     */
    initializeSymbols = () => {
      loadModules(['esri/symbols/SimpleLineSymbol', 'esri/symbols/PictureMarkerSymbol']).then(([SimpleLineSymbol, PictureMarkerSymbol]) => {
        this.routeSymbol = new SimpleLineSymbol({
          color: [88, 88, 88, 0.4],
          style: 'solid',
          join: 'round',
          width: 4
        });
        this.routeOff = new SimpleLineSymbol({
          color: [100, 100, 100, 0.4],
          style: 'solid',
          join: 'round',
          width: 4
        });
        this.routeHovered = new SimpleLineSymbol({
          color: [163, 91, 223, 0.4],
          style: 'solid',
          join: 'round',
          width: 4
        });
        this.routeSelected = new SimpleLineSymbol({
          color: [255, 107, 29, 0.4],
          style: 'solid',
          join: 'round',
          width: 4
        });
        this.boxSymbol = new PictureMarkerSymbol({
          url: 'https://gis.usps.com/eddm/assets/usps_eddm_po_orange_pin.png',
          contentType: 'image/png',
          width: 25,
          height: 32,
          angle: 0,
          xoffset: 0,
          yoffset: 16
        });
        this.searchPositionSymbol = new PictureMarkerSymbol({
          url: 'https://gis.usps.com/eddm/assets/usps_eddm_star_pin.png', // relative URL
          contentType: 'image/png',
          width: 40,
          height: 52,
          angle: 0,
          xoffset: 0,
          yoffset: 20
        });
      });
    };

    getLocation = () => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(position => {
          let latitude = position.coords.latitude;
          let longitude = position.coords.longitude;

          this.setState({center: [longitude, latitude]});
        }, error => {
          switch (error.code) {
            case error.PERMISSION_DENIED:
              console.log('Permission denied: ' + error.message);
              break;
            case error.POSITION_UNAVAILABLE:
              console.log('Cannot get position: ' + error.message);
              break;
            case error.TIMEOUT:
              console.log('Try again');
              break;
            default:
              break;
          }
        });
      }
    };

    /**
     * Manage zipcode input changes.
     * @param event
     */
    handleChange = event => {
      event.preventDefault();
      this.setState({address: event.target.value});
    };

    /**
     * Search the location by ZipCode and show the routes.
     */
    searchAddressNormal = event => {
      this.searchAddress(this.state.address, 1);
      event.preventDefault();
      // this.executeProcessor(this.state.selectedZipCode);
    };

    searchAddress = (location, distance) => {
      this.selectedRoutes.searchType = 'address';
      location = location.replace(/['.\n\f\r\t\v]/g, ' ');
      location = location.toUpperCase();
      this.addressSearched.zip = [];
      this.addressSearched.location = location;
      this.addressSearched.searchUsed = '';
      this.addressSearched.distance = distance;
      let nonZip = false;
      //* Remove commas and extra spaces
      let locArray = location.replace(/,/g, ' ').replace(/\s{2,}/g, ' ').split(' ');

      locArray.forEach((item) => { //* ** Find ZIP codes
        //* Remove non numeric
        item = item.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
        if (item.length === 5 && !isNaN(parseInt(item, 10))) {
          this.addressSearched.zip.push(item);
        } else {
          nonZip = true;
        }
      });

      if (this.addressSearched.zip.length > 0 && nonZip === false) { //* * ZIP code search
        if (this.addressSearched.zip.length > 5) {
          // this.addressSearched.zip = results[0].value.split(',');
          this.selectedRoutes.msgs.push('Too many ZIP codes submitted');
          // this.handleZip(this.addressSearched.zip, location, this.selectedRoutes.msgs);
          this.selectedRoutes.msgs = [];
        } else {
          this.selectedRoutes.usedSearch = this.addressSearched.zip.join();
          this.addressSearched.searchUsed = 'zip';
          this.selectedRoutes.searchType = 'zip';
          this.searchZIP(this.addressSearched.zip.join());
        }
      } else { // ** Address search
        var address = {
          'Single Line Input': location,
          'SingleLine': location
        };
        var options = {
          address: address,
          outFields: ['StPreDir', 'StPreType', 'StName', 'StType', 'StDir', 'City', 'Region', 'Postal']
        };
        this.selectedRoutes.usedSearch = location;
        this.selectedRoutes.msgs = [];
        this.geolocator.current.addressToLocations(options).then(this.handleGeoResults);
      }
    };

    handleGeoResults = (addresses) => {
      let geom;
      var nMatches = 0, npMatches = 0;
      let attributes = {
        address: '',
        score: '',
        locatorName: ''
      };
      this.matchedResults.candidates = [];
      addresses.forEach(candidate => {
        if (candidate.score === 100) {
          npMatches += 1;
          this.matchedResults.candidates[0] = candidate;
        } else if (candidate.score >= 85) { /// Add candidates with match >= 85
          nMatches += 1;
          this.matchedResults.candidates.push(candidate);
        } else if (candidate.score >= 80 && nMatches < 5) { /// Add candidates with match >= 80
          nMatches += 1;
          this.matchedResults.candidates.push(candidate);
        }
      });

      if (npMatches >= 1 || nMatches === 1) { /// One match with 100 percent, or one match - Address Search
        this.selectedRoutes.candidate = this.matchedResults.candidates[0];
        this.searchCandidate(this.matchedResults.candidates[0]);
      } else if (nMatches > 1 || npMatches > 1) { /// Multiple matches
        // this.handleDups(this.matchedResults.candidates, 12001);
      } else if (nMatches === 0) { /// No address matches
        if (this.addressSearched.zip.length >= 1) {
          this.selectedRoutes.usedSearch = this.addressSearched.zip.join();
          this.addressSearched.searchUsed = 'zip';
          this.selectedRoutes.searchType = 'zip';
          this.searchZIP(this.addressSearched.zip.join());
        } else {
          this.selectedRoutes.msgs = [];
          this.addressSearched.searchUsed = 'city';
          this.selectedRoutes.searchType = 'city';
          this.searchCity(this.addressSearched.location);
        }
      }
      return false;
    };
    /**
     * @description Executes city/state search
     * @method
     * @name searchCity
     * @param strInput - City / State
     * @author BS7N00
     */
    searchCity = strInput => {
      strInput = strInput.replace(/[0-9]/g, '');
      if (strInput.split(',').length > 1 || strInput.split(' ').length > 1) {
        this.selectedRoutes.msgs.push('City search used');
        let params = {
          'strInput': strInput
        };
        // this.selectCity.current.execute(params).then(this.handleCity);
      } else {
        // this.doFallback();
        this.selectedRoutes.msgs = [];
      }
    };
    searchCandidate = candidate => {
      this.selectedRoutes.usedSearch = candidate.address;
      this.selectedRoutes.msgs = [];
      let point = candidate.location;
      this.selectedRoutes.searchType = 'address';
      // MapLib.GP.drawSearchRadius(point, MapLib.GP.adressSearched.distance);
      this.executeNear(point, this.addressSearched.distance);
    };

    executeNear = (point, searchRadius) => {
      // this.drawSearchRadius(point, MapLib.GP.adressSearched.distance);
      loadModules(['esri/Graphic', 'esri/tasks/support/FeatureSet']).then(([Graphic, FeatureSet]) => {
        let graphic = new Graphic(point, this.searchPositionSymbol);
        this.viewAccesor.current.getView().graphics.add(graphic);

        var features = [];
        features.push(graphic);
        var featureSet = new FeatureSet();
        featureSet.features = features;

        //* Search C & R Routes
        var params = {
          'Selecting_Features': featureSet,
          'Distance': searchRadius,
          'Rte_Box': 'R',
          'userName': 'EDDM'
        };
        let pRoute = this.selectNearR.current.execute(params);

        //* Search PO Boxes
        params = {
          'Selecting_Features': featureSet,
          'Distance': searchRadius,
          'Rte_Box': 'B',
          'userName': 'EDDM'
        };
        let pBox = this.selectNearB.current.execute(params);
        Promise.all([pRoute, pBox]).then(this.showRoutes);
      });
    };

    /**
     * Execute route display processor
     * @param zipcode Select ZipCode
     */
    searchZIP = (zipcode) => {
      this.setState({ loading: true });
    
      const executeWhenReady = () => {
        const selectZIPR = this.selectZIPR.current;
        const selectZIPB = this.selectZIPB.current;
    
        if (selectZIPR?.execute && selectZIPB?.execute) {
          const paramsRoute = {
            ZIP: zipcode,
            Rte_Box: 'R',
            UserName: 'EDDM'
          };
          const paramsBox = {
            ZIP: zipcode,
            Rte_Box: 'B',
            UserName: 'EDDM'
          };
    
          Promise.all([
            selectZIPR.execute(paramsRoute),
            selectZIPB.execute(paramsBox)
          ])
          .then(this.showRoutes)
          .finally(() => {
            this.setState({ loading: false });
          });
        } else {
          setTimeout(executeWhenReady, 100);
        }
      };
    
      executeWhenReady();
    };

    /**
     * Promised function, this executes the promises for route info based in ZipCode
     * @param rRoute Promise of SelectZIPRoute
     * @param rBox Promise of SelectZIPBox
     */
    showRoutes = ([rRoute, rBox]) => {
      this.displayResults(rRoute.results, rRoute.messages);
      this.displayBoxResults(rBox.results, rBox.messages);

      this.renderRoutes();
    };

    /**
     * Display results of SelectZIPRoute (polygons)
     * @param results
     * @param messages
     */
    displayResults = (results, messages) => {
      let thisRoute = [];
      let resultFeatures = results[0].value.features;

      for (let i = 0, il = resultFeatures.length; i < il; i++) {
        thisRoute = [];
        thisRoute.attributes = resultFeatures[i].attributes;
        thisRoute.attributes.graphic = resultFeatures[i];
        thisRoute.attributes.graphic.isRoute = true;
        thisRoute.attributes.graphic.hovered = false;
        thisRoute.attributes.graphic.defaultSymbol = this.routeOff;
        thisRoute.attributes.graphic.offSymbol = this.routeOff;
        thisRoute.attributes.graphic.hoveredSymbol = this.routeHovered;
        thisRoute.attributes.graphic.selectedSymbol = this.routeSelected;

        this.newRoutes.features.push(thisRoute);
      }
    };

    /**
     *
     * @param results
     * @param messages
     */
    displayBoxResults = (results, messages) => {
      loadModules(['esri/geometry/SpatialReference', 'esri/Graphic', 'esri/geometry/Point']).then(([SpatialReference, Graphic, Point]) => {
        //* Get featureset from ArcServer PO Box search results
        let thisRoute = [], i, il;
        let resultFeatures = results[0].value.features;

        for (i = 0, il = resultFeatures.length; i < il; i++) {
          thisRoute = [];

          let point = new Point(resultFeatures[i].geometry.points[0], new SpatialReference({
            wkid: 102100
          }));
          let graphic = new Graphic({geometry: point});
          thisRoute.attributes = [];
          thisRoute.attributes = resultFeatures[i].attributes;
          thisRoute.attributes.graphic = graphic;
          thisRoute.attributes.graphic.isRoute = false;
          thisRoute.attributes.graphic.attributes = [];
          thisRoute.attributes.graphic.attributes = resultFeatures[i].attributes;
          thisRoute.attributes.graphic.defaultSymbol = this.boxSymbol;

          this.newRoutes.features.push(thisRoute);
        }
      });
    };

    renderRoutes = () => {
      this.newRoutes.features.forEach((feature) => {
        if (feature.attributes.graphic.isRoute) {
          this.selectedRoutes.features.push(feature);
          this.cridLayer.current.getLayer().add(feature.attributes.graphic);
        }
      });
      this.cridLayer.current.getLayer().graphics.forEach((graphic) => {
        if (graphic.symbol === undefined || graphic.symbol === null) {
          graphic.symbol = graphic.defaultSymbol;
        }
      });
      const arr = this.newRoutes.features.filter(route => route.attributes.graphic.isRoute).map((route) => {
        return {
          ...route,
          active: false
        };
      });
        // This add all routes, must be reseted all
      this.props.loadRoutesList(arr);

      this.newRoutes.features = [];

      loadModules(['esri/geometry/Extent']).then(([Extent]) => {
        let newExtent, geometry, curExtent;
        this.cridLayer.current.getLayer().graphics.forEach(graphic => {
          geometry = graphic.geometry;
          if (geometry.declaredClass === 'esri.geometry.Polyline') {
            if (newExtent) {
              newExtent = newExtent.union(geometry.extent);
            } else {
              newExtent = geometry.extent;
            }
          } else {
            if (newExtent) {
              newExtent.union(new Extent(geometry.x - 1, geometry.y - 1, geometry.x + 1, geometry.y + 1, geometry.spatialReference));
            } else {
              newExtent = new Extent(geometry.x - 1, geometry.y - 1, geometry.x + 1, geometry.y + 1, geometry.spatialReference);
            }
          }
        });

        if (newExtent) {
          this.viewAccesor.current.getView().goTo(newExtent);
        }
      });
    }
}

EDDMMap.propTypes = {
  zoom: PropTypes.number.isRequired,
  routes: PropTypes.array
};

function mapStateToProps(state, ownProps) {
  return {
    routes: state.routes,
    selectedRoutes: state.selectedRoutes,
    homes: state.homes,
    costs: state.costs,
    business: state.business,
    excludedBusiness: state.excludedBusiness
  };
}



function mapDispatchToProps(dispatch) {
  return {
    addRoute: (route) => dispatch(addRoute(route)),
    deleteRoute: (index) => dispatch(deleteRoute(index)),
    addHome: (home) => dispatch(addHomes(home)),
    subtractHome: (home) => dispatch(subtractHome(home)),
    addCost: (cost) => dispatch(addCost(cost)),
    subtractCost: (cost) => dispatch(subtractCost(cost)),
    loadRoutesList: (routes) => dispatch(loadRoutesList(routes)),
    activeRoute: (route) => dispatch(activeRoute(route)),
    deactiveRoute: (route) => dispatch(deactiveRoute(route)),
    clearTable: () => dispatch(clearTable()),
    addBusiness: (business) => dispatch(addBusiness(business)),
    subtractBusiness: (business) => dispatch(subtractBusiness(business)),
    handleExcludedBusiness: () => dispatch(excludedBusiness()),
    hoveredRoute: (route) => dispatch(hoveredRoute(route)),
    unhoveredRoute: () => dispatch(unhoveredRoute()),
    resetSelectedRoutes: () => dispatch(resetSelectedRoutes())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EDDMMap);
